import React from 'react'
import styles from './SecondaryButton.module.css'
import PropTypes from 'prop-types'

const SecondaryButton = ({
  children,
  onClick,
  disabled = false,
}) => {
  const handleClick = event => {
    event.preventDefault()
    event.stopPropagation()

    onClick(event)
  }

  return (
    <button type="button" className={ styles.button } onClick={ handleClick } disabled={ disabled }>
      { children }
    </button>
  )
}

SecondaryButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default SecondaryButton
